import React from 'react'
import { navigate } from 'gatsby'
import { useLocation } from '@reach/router'
import Alert from '@material-ui/lab/Alert'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Button from '../components/Button'
import vars from '../lib/styled'

const useStyles = makeStyles(() => ({
  alert: {
    backgroundColor: '#efeeee',
    color: vars.accent,
    '& svg': {
      fill: vars.accent,
    },
  },
}))

const isUsProduct = (path) => path.includes('/en-us')

const UsProductAlert = () => {
  const { pathname } = useLocation()
  const cls = useStyles()

  return !isUsProduct(pathname) ? null : (
    <Alert
      severity="info"
      color="info"
      action={
        <Button
          aria-label="Navigate to Canadian product page"
          role="link"
          color="primary"
          variant="contained"
          onClick={() => navigate('/en-ca/products')}
          style={{
            lineHeight: 2.5,
            padding: '0 .75rem',
            fontSize: '.733rem',
          }}
        >
          View Products
        </Button>
      }
      className={cls.alert}
    >
      Hungry for Marcangelo? View our full product lineup.
    </Alert>
  )
}

export default UsProductAlert
